import React from "react";

const TimelineComponent = () => {
  return (
    <div
      className="flex flex-col md:flex-row items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: "url('image/home/MapBG.jpg')" }}
    >
      <div className="md:w-1/2 p-8 flex justify-end">
        <div className="w-3/4">
          <div className="flex flex-col items-start">
            <div className="text-3xl mb-8 font-bold text-white">
              How It Works
            </div>
            <div className="relative">
              <div className="w-4 h-4  rounded-full border-2 border-gray-300 mb-4"></div>
              <div className="absolute top-4 left-2 h-[100px] w-0.5 bg-gray-300"></div>
            </div>
            <div className="ml-10 mb-12 text-gray-300"
                 data-aos="fade-left"
                 data-aos-duration="1000"
                 data-aos-once="true"
            >
              <h2 className="text-xl font-bold mb-2">Create Your Route</h2>
              <p className="text-sm">
                Enter your pickup & dropoff locations or the number <br />
                of hours you wish to book a car and driver for
              </p>
            </div>
          </div>
          <div className="flex flex-col items-start "
               data-aos="fade-left"
               data-aos-duration="1200"
               data-aos-once="true">
            <div className="relative">
              <div className="w-4 h-4  rounded-full border-2 border-white mb-4"></div>
              <div className="absolute top-4 left-2 h-[100px] w-1 bg-white"></div>
            </div>
            <div className="ml-10 mb-12 text-white">
              <h2 className="text-xl font-bold mb-2">Choose Vehicle For You</h2>
              <p className="text-sm">
                On the day of your ride, you will receive two email <br />
                and SMS updates - one informing you that.{" "}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-start"
               data-aos="fade-left"
               data-aos-duration="1400"
               data-aos-once="true">
            <div className="relative">
              <div className="w-4 h-4  rounded-full border-2 border-gray-300 mb-4"></div>
              <div className="absolute top-4 left-2 h-[100px] w-0.5 bg-gray-300"></div>
            </div>
            <div className="ml-10 text-gray-300">
              <h2 className="text-xl font-bold mb-2">Enjoy The Journey</h2>
              <p className="text-sm">
                After your ride has taken place, we would appreciate <br /> it
                if you could rate your car and driver.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="md:w-1/2 relative top-16 ">
        <img
          className="max-w-[90%] mt-12 ml-auto"
          src="image/home/car1.png"
          alt="Your Image"
        />
      </div>
    </div>
  );
};

export default TimelineComponent;
